import { render, staticRenderFns } from "./ModuleItem.vue?vue&type=template&id=1749d3d0"
import script from "./ModuleItem.vue?vue&type=script&lang=js"
export * from "./ModuleItem.vue?vue&type=script&lang=js"
import style0 from "./ModuleItem.vue?vue&type=style&index=0&id=1749d3d0&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports